import { FaRegTimesCircle } from "react-icons/fa";

export const ViewPicture = ({onClose,image}) =>{
    return (
        <>
        <div className="flex items-center justify-center fixed top-0 left-0 right-0 bottom-0 bg-gradient-to-b from-maroon z-10">
        <div className="overlay-inner rounded-lg bg-lightcolor w-700 h-550 p-6 relative box-border overflow-hidden ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600">
          <button className="close" onClick={onClose}>
            <FaRegTimesCircle />
          </button>
          <h2 className="text-xl pb-5 text-maroon">Your uploaded picture</h2>
          <div className="flex justify-center items-center ">
            <img src={image} className="w-auto h-auto"/>
          </div>
        </div>
      </div>
        </>
    )
}